import React from 'react'
import { View } from 'react-native'
import ScrollContainer from 'react-indiana-drag-scroll'

const TableScroll: React.FC = ({ children }) => (
  <ScrollContainer horizontal vertical={false}>
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
      }}
    >
      {children}
    </View>
  </ScrollContainer>
)

export default TableScroll
